<template>
  <div class="component-circle-progress">
    <svg class="stat-circle" width="100%" viewBox="0 0 20 20">
      <circle
        cx="10"
        cy="10"
        r="8"
        fill="none"
        stroke="#f1f1f1"
        stroke-width="2"
      />
      <circle
        cx="10"
        cy="10"
        r="8"
        fill="none"
        transform="rotate(270, 10, 10)"
        stroke-width="2"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-dasharray="51 51"
        :stroke-dashoffset="progress"
        stroke="#5576ec"
        :style="style"
      />
      <text x="50%" y="61%" fill="#555" font-size="5.5px" text-anchor="middle">
        {{ percentage }}%
      </text>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      progress: -51
    };
  },
  computed: {
    style() {
      return {
        transition: "stroke-dashoffset 400ms linear",
        strokeDashoffset: this.progress
      };
    }
  },
  methods: {
    getOffset() {
      return this.progress + (51 / 100) * this.percentage;
    }
  },
  mounted() {
    setTimeout(() => {
      this.progress = this.getOffset();
    }, 100);
  }
};
</script>
